import { render, staticRenderFns } from "./SecurityGovernmentPage.vue?vue&type=template&id=4b65ab91&scoped=true"
import script from "./SecurityGovernmentPage.vue?vue&type=script&lang=js"
export * from "./SecurityGovernmentPage.vue?vue&type=script&lang=js"
import style0 from "./SecurityGovernmentPage.vue?vue&type=style&index=0&id=4b65ab91&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b65ab91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b65ab91')) {
      api.createRecord('4b65ab91', component.options)
    } else {
      api.reload('4b65ab91', component.options)
    }
    module.hot.accept("./SecurityGovernmentPage.vue?vue&type=template&id=4b65ab91&scoped=true", function () {
      api.rerender('4b65ab91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/SecurityGovernmentPage.vue"
export default component.exports